<template>
  <div id="webchatApp">
    <loading
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <transition name="fade"> 
      <keep-alive >
      <router-view />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);
export default {
  name: "app",
  metaInfo: {
    title: "Index",
    titleTemplate: "%s -Tactful.ai-Dashboard"   //Not used anywhere!
  },
  data() {
    return {
      fullPage: true,
    };
  },
  watch :{
    '$route'(to,from){
      if(from.meta.order>to.meta.order||from.meta.order<to.meta.order){
       let loader = this.$loading.show({
                loader: 'dots',                
              });
            setTimeout(() => loader.hide(), 2 * 1000);
      }
    }

  },
  components: {
    Loading
  }
};
</script>
<style>
 html {
  overflow-x: hidden;
}
/* html::-webkit-scrollbar {
  width: 0.4em;
}
html::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
html::-webkit-scrollbar-thumb {
  background-color: #b0b0b0;
  border-radius: 5px;
  outline: 1px solid #b0b0b0;
}  */
.fade-enter-active{
  transition: opacity 5s;
}
.fade-enter{
  opacity: 0;
}
</style>



